<template>
  <div class="popup">
    <div class="inner">
      <div class="popup-header" :class="{ 'c-warning': typeIsWarning }">
        <ELordIcon
          v-if="showHeaderNoticeIcon"
          style="max-width: 24px; max-height: 24px"
          stoke="100"
          icon="questionMark"
          primary-color="#F7A111"
          secondary-color="#F7A111"
          @click="showHeaderNotice = !showHeaderNotice"
        />
        <div class="header-content">
          <h4>
            <slot name="header-text" />
          </h4>
          <span class="header-notice" v-if="showHeaderNotice">
            <slot name="header-notice" />
          </span>
        </div>

        <ELordIcon icon="close" stoke="100" @click="close" />
      </div>
      <div class="popup-body">
        <slot name="body" />
      </div>
      <div class="popup-footer" v-if="hasSlotFooter">
        <slot name="footer" />
      </div>
    </div>
    <div class="overlay" @click="close"></div>
  </div>
</template>

<script>
import ELordIcon from '@/components/utilities/ELordIcon';

export default {
  name: 'PopupBase',
  components: { ELordIcon },
  data() {
    return {
      showHeaderNotice: false,
    };
  },
  props: {
    showHeaderNoticeIcon: {
      type: Boolean,
      default: true,
    },
    typeIsWarning: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
  computed: {
    hasSlotFooter() {
      return Boolean(this.$slots.footer);
    },
  },
};
</script>
